import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "d-flex gap-10 justify-content-between" }
const _hoisted_3 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body py-4" }
const _hoisted_11 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_12 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "min-w-125px" }
const _hoisted_16 = { class: "text-center min-w-150px" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_22 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]

import { ref, onMounted, watch, inject } from "vue";
import { CommentType } from "@/core/types/CommentType";
import TableFooter from "@/components/TableFooter.vue";
import AccountRequestApprove from "../components/AccountRequestApprove.vue";
import AccountService from "../services/AccountService";
import TimeShow from "@/components/TimeShow.vue";
import UserDetails from "../../../components/UserDetails.vue";
import { FetchedDataType } from "../types/FetchedDataType";
import {
  ApplicationStatusType,
  ApplicationType,
  getApplicationStatusType,
} from "@/core/types/ApplicationInfos";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import RejectReasonBox from "@/components/RejectReasonBox.vue";
import OpenProcedureForm from "../components/OpenProcedureForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useRoute, useRouter } from "vue-router";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import { Search } from "@element-plus/icons-vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";

enum TabStatus {
  pending = 1,
  approved = 2,
  rejected = 3,
  completed = 4,
  all = 5,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountApplications',
  setup(__props) {

const isLoading = ref(true);
const tradeAccountApplications = ref(Array<any>());
// const tradeAccountApplications = ref(Array<any>());
const userDetailsRef = ref<InstanceType<typeof UserDetails>>();
const rejectReasonBoxRef = ref<InstanceType<typeof RejectReasonBox>>();
const openProcedureFormRef = ref<InstanceType<typeof OpenProcedureForm>>();

const rejectHandler = ref(() => Promise.resolve());

// current chosen tab: Pending, Approved, Rejected
const statusTypes = getApplicationStatusType();
const tab = ref(TabStatus.pending);

const route = useRoute();
const router = useRouter();

const AccountRequestApproveModel = ref(null);

const serviceMap = ref({} as any);

const criteria = ref<any>({
  page: 1,
  size: 10,
  status: TabStatus.pending,
  type: ApplicationType.TradeAccount,
});

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  try {
    isLoading.value = true;
    const res = await AccountService.queryApplications(criteria.value);
    criteria.value = res.criteria;
    tradeAccountApplications.value = res.data.map((item: any) => ({
      ...item,
      user: {
        ...item.user,
        partyId: item.partyId,
      },
    }));
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const openCommentView = inject<
  (type: CommentType, id: number, title: string) => any
>(InjectKeys.OPEN_COMMENT_VIEW, () => null);

const handleBeforeClose = () => {
  router.push({ name: "AccountApplications" });
};

watch(
  () => route.query.id,
  async () => {
    if (route.query.id) {
      await fetchData(1);
      openApplicationDetailsFromRoute();
    }
  }
);

const openApplicationDetailsFromRoute = () => {
  const applicationDetails = tradeAccountApplications.value.find(
    (item) => item.id === Number(route.query.id)
  );
  if (applicationDetails) {
    openProcedureFormRef.value?.show(1, { applicationDetails });
  }
};

onMounted(async () => {
  serviceMap.value = await GlobalService.getServiceMap();
  await fetchData(criteria.value.page);
  //  openProcedureFormRef?.show(1, { applicationDetails: item })
  if (route.query?.id) {
    openApplicationDetailsFromRoute();
  }
});
const changeTab = (_tab: TabStatus) => {
  tab.value = _tab;
  criteria.value.status =
    {
      [TabStatus.approved]: ApplicationStatusType.Approved,
      [TabStatus.pending]: ApplicationStatusType.AwaitingApproval,
      [TabStatus.rejected]: ApplicationStatusType.Rejected,
      [TabStatus.completed]: ApplicationStatusType.Completed,
    }[_tab] ?? null;

  fetchData(1);
};

const pageChange = (page: number) => {
  fetchData(page);
};

const approveSubmit = (data: FetchedDataType) => {
  console.log(data);
};

const openReject = inject(
  TenantGlobalInjectionKeys.OPEN_REJECT_REASON_MODAL,
  (...args) => MsgPrompt.info(...args)
);

const openConfirm = inject(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL,
  (...args) => MsgPrompt.info(...args)
);
const openRejectReasonBox = (applicationId: number) => {
  // rejectHandler.value = (formData?: any) =>
  //   AccountService.rejectApplicationsById(applicationId, formData);
  // rejectReasonBoxRef.value?.show();

  openReject((formData) =>
    AccountService.rejectApplicationsById(applicationId, formData).then(() =>
      fetchData(criteria.value.page)
    )
  );
};

const openReverseBox = (applicationId: number) => {
  openConfirm(() =>
    AccountService.reverseApplicationsById(applicationId).then(() =>
      fetchData(criteria.value.page)
    )
  );
};

const search = () => {
  tab.value = TabStatus.all;
  changeTab(TabStatus.all);
  criteria.value.status = null;
  fetchData(1);
};
const reset = () => {
  criteria.value.email = "";
  criteria.value.partyId = null;
  fetchData(1);
};
const showRejectReason = (item: any) => {
  openConfirm(void 0, void 0, {
    confirmText: item.rejectedReason,
    disableFooter: true,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("a", {
              class: _normalizeClass([
              'nav-link text-active-primary pb-4',
              { active: tab.value === TabStatus.pending },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]),
              "data-bs-toggle": "tab",
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(TabStatus.pending)))
            }, _toDisplayString(_ctx.$t("status.pending")), 3)
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", {
              class: _normalizeClass([
              'nav-link text-active-primary pb-4',
              { active: tab.value === TabStatus.approved },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]),
              "data-bs-toggle": "tab",
              href: "#",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(TabStatus.approved)))
            }, _toDisplayString(_ctx.$t("status.approved")), 3)
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", {
              class: _normalizeClass([
              'nav-link text-active-primary pb-4',
              { active: tab.value === TabStatus.completed },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]),
              "data-bs-toggle": "tab",
              href: "#",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(TabStatus.completed)))
            }, _toDisplayString(_ctx.$t("status.completed")), 3)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              class: _normalizeClass([
              'nav-link text-active-primary pb-4',
              { active: tab.value === TabStatus.rejected },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]),
              "data-kt-countup-tabs": "true",
              "data-bs-toggle": "tab",
              href: "#",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(TabStatus.rejected)))
            }, _toDisplayString(_ctx.$t("status.rejected")), 3)
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", {
              class: _normalizeClass([
              'nav-link text-active-primary pb-4',
              { active: tab.value === TabStatus.all },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]),
              "data-bs-toggle": "tab",
              href: "#",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(TabStatus.all)))
            }, _toDisplayString(_ctx.$t("status.all")), 3)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            class: "w-400px",
            modelValue: criteria.value.email,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.email) = $event)),
            clearable: true,
            placeholder: "Email"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: search
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            class: "ms-4",
            type: "info",
            plain: "",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_12, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.id")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                (tab.value === TabStatus.all)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.status")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.site")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountType")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.leverage")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.platform")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.server")), 1),
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && tradeAccountApplications.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tradeAccountApplications.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.id) + " ", 1),
                          (_ctx.$can('Admin'))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "ms-2 cursor-pointer",
                                role: "button",
                                onClick: ($event: any) => (
                    _unref(openCommentView)(
                      _unref(CommentType).Application,
                      item.id,
                      item.user?.firstName + ' ' + item.user?.lastName
                    )
                  )
                              }, [
                                (item.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_22))
                              ], 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          _createTextVNode(" / " + _toDisplayString(item.partyId), 1)
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createVNode(_component_UserInfo, {
                            url: "#",
                            user: item.user,
                            class: "me-2"
                          }, null, 8, ["user"])
                        ]),
                        (tab.value === TabStatus.all)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(_unref(statusTypes)[item.status]), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.siteType.${item.siteId}`)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.account.${item.supplement.accountType}`)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement.currencyId
                    ? _ctx.$t(`type.currency.${item.supplement.currencyId}`)
                    : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement.leverage
                    ? item.supplement.leverage + ":1"
                    : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(serviceMap.value[item.supplement.serviceId]?.platformName ?? "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(serviceMap.value[item.supplement.serviceId]?.serverName ?? "***"), 1),
                        _createElementVNode("td", null, _toDisplayString({
                    2: item.operatorName.split(",")[0],
                    3: item.operatorName.split(",")[1],
                    4: item.operatorName.split(",")[2],
                  }[item.status] ?? "--"), 1),
                        _createElementVNode("td", null, [
                          _createVNode(TimeShow, {
                            "date-iso-string": item.createdOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", {
                          class: _normalizeClass({ 'text-center': tab.value != TabStatus.all })
                        }, [
                          _withDirectives(_createElementVNode("button", {
                            class: "btn btn-light btn-success btn-sm me-3",
                            onClick: ($event: any) => (
                    openProcedureFormRef.value?.show(1, { applicationDetails: item })
                  )
                          }, _toDisplayString(_ctx.$t("action.details")), 9, _hoisted_25), [
                            [_vShow, tab.value !== TabStatus.approved]
                          ]),
                          _withDirectives(_createElementVNode("button", {
                            class: "btn btn-light btn-success btn-sm me-3",
                            onClick: ($event: any) => (
                    openProcedureFormRef.value?.show(2, { applicationDetails: item })
                  )
                          }, _toDisplayString(_ctx.$t("action.openMt")), 9, _hoisted_26), [
                            [_vShow, 
                    item.status == TabStatus.approved &&
                    item.supplement.role === _unref(AccountRoleTypes).Client
                  ]
                          ]),
                          (item.status == TabStatus.pending)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                href: "#",
                                class: "btn btn-light btn-danger btn-sm",
                                onClick: ($event: any) => (openRejectReasonBox(item.id))
                              }, _toDisplayString(_ctx.$t("action.reject")), 9, _hoisted_27))
                            : _createCommentVNode("", true),
                          (item.status == TabStatus.rejected)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-light btn-info btn-sm",
                                onClick: ($event: any) => (showRejectReason(item))
                              }, _toDisplayString(_ctx.$t("action.viewReasons")), 9, _hoisted_28))
                            : _createCommentVNode("", true),
                          (item.status == TabStatus.rejected)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 2,
                                type: "warning",
                                class: "ms-3",
                                onClick: ($event: any) => (openReverseBox(item.id))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Reverse ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(TableFooter, {
            onPageChange: pageChange,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ])
    ]),
    _createVNode(OpenProcedureForm, {
      ref_key: "openProcedureFormRef",
      ref: openProcedureFormRef,
      onStepFinished: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1))),
      "before-close": handleBeforeClose
    }, null, 512),
    _createVNode(AccountRequestApprove, {
      ref_key: "AccountRequestApproveModel",
      ref: AccountRequestApproveModel,
      onApproved: approveSubmit
    }, null, 512),
    _createVNode(UserDetails, {
      ref_key: "userDetailsRef",
      ref: userDetailsRef
    }, null, 512),
    _createVNode(RejectReasonBox, {
      ref_key: "rejectReasonBoxRef",
      ref: rejectReasonBoxRef,
      handleSubmit: rejectHandler.value,
      onRejected: _cache[7] || (_cache[7] = ($event: any) => (fetchData(criteria.value.page)))
    }, null, 8, ["handleSubmit"])
  ], 64))
}
}

})